import { sortBy } from "lodash";
import { useNavigate } from "react-router-dom";
import { CategoryReport } from "./CategoryReport";

interface ICategoryLegendProps {
  data: CategoryReport[];
}

const CategoryLegend = (props: ICategoryLegendProps) => {
  // Hooks
  const navigate = useNavigate();

  // Handlers
  const onClick = (record: CategoryReport) => {
    navigate("/RfiList", { state: { category: record.category } });
  };

  const entries = sortBy(
    props.data,
    (entry: CategoryReport) => {
      return entry.value;
    },
    "desc"
  ).reverse();

  // Render
  return (
    <div>
      {entries?.map((record: CategoryReport, index: number) => {
        return (
          <div
            tabIndex={0}
            key={index}
            className="d-flex flex-row justify-content-start"
            role="button"
            onClick={() => onClick(record)}
            onKeyDown={(event: any) => {
              if (event.keyCode === 13) {
                onClick(record);
              }
            }}
          >
            <div className="p-1">
              <span style={{ color: record.color }}>
                <i className="fa-solid fa-circle"></i>
              </span>
            </div>
            <div className="p-1">{record.category}</div>
            <div className="flex-grow-1"></div>
            <div className="p-1 ml-auto">{record.value}</div>
          </div>
        );
      })}
    </div>
  );
};

export default CategoryLegend;
